import * as React from 'react';
import loc from 'owa-localize';
import { loadingAssetsFailedMessage } from './CanvasConfig.locstring.json';

export const DEFAULT_CANVAS_CONFIG: CanvasConfig = {
    enableFeedback: true,
    feedbackDisplayArea: undefined,
    enableCanvasLock: false,
    getLoadingAssetsFailedMessage: () => loc(loadingAssetsFailedMessage),
};

const CanvasConfigContext = React.createContext<CanvasConfig>(DEFAULT_CANVAS_CONFIG);
CanvasConfigContext.displayName = 'CanvasConfigContext';

export interface CanvasConfig {
    enableFeedback: boolean;
    feedbackDisplayArea?: string;
    enableCanvasLock: boolean;
    getLoadingAssetsFailedMessage: () => string;
}

export const CanvasConfigProvider = CanvasConfigContext.Provider;

/**
 * Hook that return the canvas config
 */
export function useCanvasConfig() {
    return React.useContext(CanvasConfigContext);
}
